import { ChevronLeft, ChevronRight } from "lucide-react";

const VARIANTS = {
    orange: {
        ring: "focus:ring-orange-400",
        navHover: "hover:bg-orange-600 hover:text-white",
        goBtn: "bg-orange-500 text-white hover:bg-orange-600",
    },
    blue: {
        ring: "focus:ring-blue-500",
        navHover: "hover:bg-blue-600 hover:text-white",
        goBtn: "bg-blue-600 text-white hover:bg-blue-500",
    },
};

export const Pagination = ({
    currentPage,
    className = "" ,
    setCurrentPage,
    rowsPerPage,
    totalPages,
    setRowsPerPage ,
    addJump = true ,
    jumpToPage ,
    pageJump ,
    setPageJump ,
    variant = "orange" }) => {
    const v = VARIANTS[variant] ?? VARIANTS.orange;
    return (<div className={`flex flex-wrap gap-4 justify-between items-center mt-3 ${className}`}>
        {/* Rows per page selector */}
        <div>
            <label className="mr-2">Rows per page:</label>
            <select
                value={rowsPerPage}
                onChange={(e) => {
                    setRowsPerPage(Number(e.target.value));
                    setCurrentPage(1); // reset page
                }}
                className={`border rounded px-2 py-1 bg-white text-gray-800 border-gray-300 focus:outline-none focus:ring-2 ${v.ring} transition dark:bg-slate-800 dark:text-gray-100 dark:border-gray-700`}
            >
                {[10, 20, 50].map((num) => (
                    <option key={num} value={num}>{num}</option>
                ))}
            </select>
        </div>

        {/* Pagination buttons */}
        <div className="flex flex-wrap items-center gap-2">
            <button
    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
    disabled={currentPage === 1}
    className={`flex items-center gap-1 px-3 py-1 border rounded-xl ${v.navHover} transition-all disabled:opacity-50 disabled:cursor-not-allowed`}
  >
    <ChevronLeft size={16} />
    Prev
  </button>

            <span>
                Page {currentPage} of {totalPages}
            </span>
            {addJump && (<div className="flex items-center gap-2">
                <label className="text-sm text-gray-600 dark:text-gray-300" htmlFor="page-jump">
                    Jump to
                </label>
                <input
                    id="page-jump"
                    type="number"
                    min="1"
                    max={totalPages}
                    value={pageJump}
                    onChange={(e) => setPageJump(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && jumpToPage()}
                    className={`w-16 px-2 py-1 border rounded text-sm focus:outline-none focus:ring-2 ${v.ring} dark:border-gray-700 dark:bg-slate-800 dark:text-gray-100`}
                />
                <button
                    onClick={jumpToPage}
                    className={`px-3 py-1 border rounded ${v.goBtn} transition`}
                >
                    Go
                </button>
            </div>)}
             <button
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
            className={`flex items-center gap-1 px-3 py-1 border rounded-xl ${v.navHover} transition-all disabled:opacity-50 disabled:cursor-not-allowed`}
        >
            Next
            <ChevronRight size={16} />
        </button>
        </div>
    </div>)
}